import React from 'react';

export const cssPropertiesTable = {
    border: '2px solid #0077d9'
} as React.CSSProperties;
